export default __webpack_public_path__ + "static/media/desktop-home-page-banner.e66a6376.png";